import React, { useEffect, useState } from "react";

import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Logout, Settings } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImgAmigoLeo from "../../assets/images/pngs/LogoAmigoLeo.png";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import "./index.css";
import { slide as MenuBurger } from "react-burger-menu";
import { Link, useNavigate } from "react-router-dom";
import storage from "../../services/storage";
import { remove } from "react-cookies";
import ApiServices from "../../services/apiServices";
import Mask from "../../services/mask";
import { useLoad } from "../../context";
import moment from "moment";
import { IoMenuSharp, IoClose } from "react-icons/io5";

export default function HeaderLogado() {
  const [user] = useState(storage.get("USUARIO"));
  const [saldo, setSaldo] = useState("");
  const [mostrarSaldo, setMostrarSaldo] = useState(false);
  const [loadPontos, setLoadPontos] = useState(false);
  const [usuarioInfos] = useState(storage.get("USUARIO")?.loginResponse);
  const { load, setLoad } = useLoad();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const [menuAberto, setMenuAberto] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const pathname = () => {
    return window.location.pathname;
  };

  useEffect(() => {
    pathname();
    // Carregar saldo automaticamente no mobile
    const isMobile = window.innerWidth <= 768;
    if (isMobile && usuarioInfos?.token) {
      fnCarregarSaldo();
      setMostrarSaldo(true);
    }
  }, [navigate]);

  async function fnCarregarSaldo() {
    var init = {
      token: usuarioInfos?.token,
      mes: "",
      ano: "",
    };
    try {
      setLoad(true);
      setLoadPontos(true);
      let response = await ApiServices.apiPost("vitrineorder/saldo", init);

      setSaldo(Mask.numeroPontos(response.data.balance.toString()));
      setLoadPontos(false);
      // setSaldo(Mask.numeroPontos((2000).toString()));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  // async function fnEu() {
  //   try {
  //     setLoad(true);
  //     setLoadPontos(true);
  //     let response = await ApiServices.apiGet("eu");
  //   } catch (err) {
  //     console.error("err", err);
  //   } finally {
  //     setLoad(false);
  //   }
  // }
  // useEffect(() => {
  //   fnEu();
  // }, []);
  function fnMostrarSaldo() {
    if (mostrarSaldo) {
      setMostrarSaldo(false);
    } else {
      setMostrarSaldo(true);
      fnCarregarSaldo();
    }
  }

  return (
    <>
      <div className=" divHeader desktop d-flex justify-content-center w-100">
        <div className=" container d-flex justify-content-between align-items-center">
          <Link to="/home">
            <img width={50} src={ImgAmigoLeo} alt="logo amigo leo" />
          </Link>

          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ flex: 1 }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                minWidth: "710px",
              }}
            >
              <Link to="/home">
                <div
                  className={
                    "btn-menu " + (pathname() === "/home" ? "btn-ativado" : "")
                  }
                >
                  <span className="text-menu">INÍCIO</span>
                </div>
              </Link>

              {/* <Link to="/novidades">
              <div
                className={
                  "btn-menu " +
                  (pathname() === "/novidades" ? "btn-ativado" : "")
                }
              >
                <span className="text-menu" style={{ color: "#ffd300" }}>
                ANIVERSÁRIO LEO
                </span>
              </div>
            </Link> */}

              <div
                className={
                  "btn-menu " +
                  (pathname().includes("catalogo") ? " btn-ativado" : "")
                }
              >
                <span data-bs-toggle="dropdown" className="text-menu">
                  CATÁLOGO
                </span>
                <ul className="dropdown-menu">
                  <Link to="/catalogo/vitrine-leo">
                    <span className="dropdown-item text-menu">VITRINE LEO</span>
                  </Link>
                  {!storage.get("gestaoMenu").catalogo && (
                    <Link to="/catalogo/mais-premios ">
                      <span className="dropdown-item text-menu">
                        MAIS PRÊMOS
                      </span>
                    </Link>
                  )}
                  {!storage.get("gestaoMenu").catalogoTimeDeCraques && (
                    <Link to="/catalogo/time-de-craques">
                      <span className="dropdown-item text-menu">
                        TIME DE CRAQUES
                      </span>
                    </Link>
                  )}
                </ul>
              </div>
              <div
                className={
                  "btn-menu " +
                  (pathname().includes("extrato") ? " btn-ativado" : "")
                }
              >
                {!(
                  storage.get("gestaoMenu")?.meusVouchers &&
                  storage.get("gestaoMenu")?.meusPontos
                ) && (
                  <span data-bs-toggle="dropdown" className="text-menu">
                    EXTRATO
                  </span>
                )}

                <ul className="dropdown-menu">
                  {!storage.get("gestaoMenu")?.meusVouchers && (
                    <Link to="/extrato/meus-vouchers">
                      <span className="dropdown-item text-menu">
                        MEUS VOUCHERS
                      </span>
                    </Link>
                  )}
                  {!storage.get("gestaoMenu")?.meusPontos && (
                    <Link to="/extrato/meus-pontos">
                      <span className="dropdown-item text-menu">
                        MEUS PONTOS
                      </span>
                    </Link>
                  )}
                </ul>
              </div>

              {/* <Link to="/contatos">
              <div
                className={
                  "btn-menu " +
                  (pathname() === "/contatos" ? "btn-ativado" : "")
                }
              >
                <span className="text-menu">CONTATO</span>
              </div>
            </Link> */}

              <Link
                to="https://api.whatsapp.com/send/?phone=5508005910127"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  className={
                    "btn-menu my-2 " +
                    (pathname() === "/contatos" ? "btn-ativado" : "")
                  }
                >
                  <span className="text-menu">CONTATO</span>
                </div>
              </Link>

              <Link to="/faq">
                <div
                  className={
                    "btn-menu " + (pathname() === "/faq" ? "btn-ativado" : "")
                  }
                >
                  <span className="text-menu">FAQ</span>
                </div>
              </Link>

              <Link to="/regulamento">
                <div
                  className={
                    "btn-menu " +
                    (pathname() === "/regulamento" ? "btn-ativado" : "")
                  }
                >
                  <span className="text-menu">REGULAMENTO</span>
                </div>
              </Link>

              {new Date() >= new Date("2025-06-09T00:00:00") ||
              storage.get("MOSTRAR") == true
                ? !storage.get("gestaoMenu")?.timeDeCraques && (
                    <Link>
                      <form
                        action={
                          process.env.REACT_APP_COPA_PORTAL +
                          "auth/default.aspx"
                        }
                        method="POST"
                        style={{ display: "none" }}
                      >
                        <input
                          type="hidden"
                          name="token"
                          value={usuarioInfos?.token}
                        />
                      </form>
                      <div onClick={() => document.forms[0].submit()}>
                        <div className={"btn-menu my-2 "}>
                          <span className="text-menu">TIME DE CRAQUES</span>
                        </div>
                      </div>
                    </Link>
                  )
                : null}
              {!storage.get("gestaoMenu")?.pesquisa && (
                <Link to="/pesquisa">
                  <div
                    className={
                      "btn-menu " +
                      (pathname() === "/pesquisa" ? "btn-ativado" : "")
                    }
                  >
                    <span className="text-menu">PESQUISA</span>
                  </div>
                </Link>
              )}
              {/* <Link to="/retrospectiva">
              <div
                className={
                  "btn-menu " +
                  (pathname() === "/retrospectiva" ? "btn-ativado" : "")
                }
              >
                <span className="text-menu">RETROSPECTIVA</span>
              </div>
            </Link> */}
            </div>
            <div
              style={{
                width: "80%",
                height: "1px",
                backgroundColor: "#ffffff58",
              }}
            ></div>
            {window.location.pathname !== "/retrospectiva" && (
              <div className="espacoHeader d-flex flex-column">
                <div className="textosHomeInfo d-flex justify-content-center align-content-center">
                  <span className="textBemVindo px-3">
                    Olá, {usuarioInfos?.profile?.nome}, seja bem-vindo!
                  </span>
                  <span className="textCategoria px-3">
                    Categoria: {usuarioInfos?.profile?.categoria}
                  </span>
                  <span className="marginDireitaHeader ps-1">
                    Seu saldo:&nbsp;&nbsp;
                    <b>
                      {mostrarSaldo
                        ? loadPontos
                          ? "•••"
                          : saldo || "•••"
                        : "•••"}
                    </b>
                  </span>
                  PONTOS
                  <span
                    className="marginDireitaHeader"
                    onClick={() => fnMostrarSaldo()}
                  >
                    {mostrarSaldo ? (
                      <VisibilityIcon style={{ fontSize: "15px" }} />
                    ) : (
                      <VisibilityOffIcon style={{ fontSize: "15px" }} />
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>

          <span className="avatar pointer" data-bs-toggle="dropdown">
            {user?.loginResponse?.profile?.nome?.replace(" ", "").slice(0, 2)}
            <KeyboardArrowDownIcon className="setaBaixo" />
          </span>

          <ul className="dropdown-menu dropdown-menu-end ">
            <Link to="/meus-dados">
              <span className="dropdown-item text-menu">MEUS DADOS</span>
            </Link>
            {user?.loginResponse && (
              <Link
                to="https://www.leomadeiras.com.br"
                onClick={() => {
                  storage.del("TOKEN");
                  storage.del("USUARIO");
                  remove("token");
                }}
              >
                <span className="dropdown-item text-menu">SAIR</span>
              </Link>
            )}
          </ul>
        </div>
      </div>
      <div className="fixarHeader">
        <div className="divHeader mobile menuMobileCenter mobileLogado">
          {/* Header Info - Visível quando menu está fechado */}
          <div className="mobile-header-info">
            <div className="mobile-header-content">
              <div className="mobile-welcome-row">
                <div className="mobile-welcome-text">
                  {usuarioInfos?.profile?.nome}
                </div>
                <div className="d-flex align-items-center mobile-welcome-text">
                  SEU SALDO:&nbsp;&nbsp;
                  {loadPontos ? "•••" : saldo || "•••"}
                  &nbsp;&nbsp;PONTOS
                </div>
              </div>
            </div>
          </div>

          {/* Botão do menu customizado */}
          <button
            className={`mobile-menu-button ${menuAberto ? "menu-aberto" : ""}`}
            onClick={() => setMenuAberto(!menuAberto)}
            aria-label="Menu"
          >
            {menuAberto ? (
              <IoClose size={32} color="#fff" />
            ) : (
              <IoMenuSharp size={28} color="#fff" />
            )}
          </button>

          <MenuBurger
            right
            className="bm-burger-bars-Deslogado"
            isOpen={menuAberto}
            onStateChange={(state) => setMenuAberto(state.isOpen)}
            customBurgerIcon={false}
          >
            <div className="menu-container">
              {/* Top Section - Lighter Green */}
              <div className="menu-top-section">
                <div className="menu-close-button-container">
                  <button
                    className="menu-close-button"
                    onClick={() => setMenuAberto(false)}
                    aria-label="Fechar menu"
                  >
                    <IoClose size={32} color="#fff" />
                  </button>
                </div>
                <div className="d-flex justify-content-center">
                  <img width={80} src={ImgAmigoLeo} alt="logo amigo leo" />
                </div>
              </div>

              {/* Middle Section - Darker Green */}
              <div className="menu-middle-section">
                <Link to="/home" onClick={() => setMenuAberto(false)}>
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname() === "/home" ? "btn-ativado" : "")
                    }
                  >
                    <span>INÍCIO</span>
                  </div>
                </Link>
                <Link
                  to="/catalogo/vitrine-leo"
                  onClick={() => setMenuAberto(false)}
                >
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname().includes("vitrine-leo") ? " btn-ativado" : "")
                    }
                  >
                    <span>VITRINE LEO</span>
                  </div>
                </Link>
                {!storage.get("gestaoMenu")?.catalogo && (
                  <Link
                    to="/catalogo/mais-premios"
                    onClick={() => setMenuAberto(false)}
                  >
                    <div
                      className={
                        "btn-menu my-2 " +
                        (pathname().includes("mais-premios")
                          ? " btn-ativado"
                          : "")
                      }
                    >
                      <span>MAIS PRÊMIOS</span>
                    </div>
                  </Link>
                )}
                {!storage.get("gestaoMenu")?.catalogoTimeDeCraques && (
                  <Link
                    to="/catalogo/time-de-craques"
                    onClick={() => setMenuAberto(false)}
                  >
                    <div
                      className={
                        "btn-menu my-2 " +
                        (pathname().includes("time-de-craques")
                          ? " btn-ativado"
                          : "")
                      }
                    >
                      <span className="desktop-only-text">TIME DE CRAQUES</span>
                      <span className="mobile-only-text">
                        CATÁLOGO TIME DE CRAQUES
                      </span>
                    </div>
                  </Link>
                )}

                {!storage.get("gestaoMenu")?.meusVouchers && (
                  <Link
                    to="/extrato/meus-vouchers"
                    onClick={() => setMenuAberto(false)}
                  >
                    <div
                      className={
                        "btn-menu my-2 " +
                        (pathname().includes("meus-vouchers")
                          ? " btn-ativado"
                          : "")
                      }
                    >
                      <span>MEUS VOUCHERS</span>
                    </div>
                  </Link>
                )}
                {!storage.get("gestaoMenu")?.meusPontos && (
                  <Link
                    to="/extrato/meus-pontos"
                    onClick={() => setMenuAberto(false)}
                  >
                    <div
                      className={
                        "btn-menu my-2 " +
                        (pathname().includes("meus-pontos")
                          ? " btn-ativado"
                          : "")
                      }
                    >
                      <span>MEUS PONTOS</span>
                    </div>
                  </Link>
                )}
              </div>

              {/* Bottom Section - Lighter Green */}
              <div className="menu-bottom-section">
                <Link
                  to="https://api.whatsapp.com/send/?phone=5508005910127"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setMenuAberto(false)}
                >
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname() === "/contatos" ? "btn-ativado" : "")
                    }
                  >
                    <span>CONTATO</span>
                  </div>
                </Link>

                <Link to="/faq" onClick={() => setMenuAberto(false)}>
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname() === "/faq" ? "btn-ativado" : "")
                    }
                  >
                    <span>FAQ</span>
                  </div>
                </Link>

                <Link to="/regulamento" onClick={() => setMenuAberto(false)}>
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname() === "/regulamento" ? "btn-ativado" : "")
                    }
                  >
                    <span>REGULAMENTO</span>
                  </div>
                </Link>

                {!storage.get("gestaoMenu")?.pesquisa && (
                  <Link to="/pesquisa" onClick={() => setMenuAberto(false)}>
                    <div
                      className={
                        "btn-menu my-2 " +
                        (pathname() === "/pesquisa" ? "btn-ativado" : "")
                      }
                    >
                      <span>PESQUISA</span>
                    </div>
                  </Link>
                )}

                {new Date() >= new Date("2025-06-09T00:00:00") ||
                storage.get("MOSTRAR") == true
                  ? !storage.get("gestaoMenu")?.timeDeCraques && (
                      <div
                        onClick={() => {
                          setMenuAberto(false);
                          document.forms[0].submit();
                        }}
                      >
                        <form
                          action={
                            process.env.REACT_APP_COPA_PORTAL +
                            "auth/default.aspx"
                          }
                          method="POST"
                          style={{ display: "none" }}
                        >
                          <input
                            type="hidden"
                            name="token"
                            value={usuarioInfos?.token}
                          />
                        </form>
                        <div className={"btn-menu my-2 "}>
                          <span>TIME DE CRAQUES</span>
                        </div>
                      </div>
                    )
                  : null}

                <Link to="/meus-dados" onClick={() => setMenuAberto(false)}>
                  <div
                    className={
                      "btn-menu my-2 " +
                      (pathname() === "/meus-dados" ? "btn-ativado" : "")
                    }
                  >
                    <span>MEUS DADOS</span>
                  </div>
                </Link>

                <Link
                  to="https://www.leomadeiras.com.br"
                  onClick={() => {
                    setMenuAberto(false);
                    storage.del("TOKEN");
                    storage.del("USUARIO");
                    remove("token");
                  }}
                >
                  <div className="btn-menu my-2">
                    <span>SAIR</span>
                  </div>
                </Link>
              </div>
            </div>
          </MenuBurger>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: "4px",
          display: "flex",
        }}
      >
        <div style={{ flex: 1, background: "#fab206" }}></div>
        <div style={{ flex: 1, background: "#1a805b" }}></div>
        <div style={{ flex: 1, background: "#fff001" }}></div>
        <div style={{ flex: 1, background: "#fab206" }}></div>
        <div style={{ flex: 1, background: "#e76801" }}></div>
        <div style={{ flex: 1, background: "#124735" }}></div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open && anchorEl.id === "perfil"}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Link to="/meus-dados">
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Meus Dados
          </Link>
        </MenuItem>

        <Link
          to="/deslogado"
          onClick={() => {
            storage.del("TOKEN");
            storage.del("USUARIO");
          }}
        >
          <MenuItem>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Sair
          </MenuItem>
        </Link>
      </Menu>
    </>
  );
}
